import React from 'react';
import axios from 'axios';
import miniCartClient from '../util/miniCartClient'
import { addResourceStrings, translateResourceString } from '../util/translationUtility';
import { MessagesList, ERROR_USER_ALERT } from '../SharedComponents/UserMessaging/';

import Item from './Item';

let messageId = 0;
const createUserMessage = ({ text, type }) => ({ id: messageId++, text, type });

class MyItemsApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            totalItems: 0,
            itemsList: [],
            userMessages: [],
        };

        addResourceStrings(props.LocalizationItems);
    }

    async componentDidMount() {
        this.loadMoreItems();
    }

    loadMoreItems = () => {
        const fetchUrl = this.props.GetMyItemsEndpoint;

        fetch(
            fetchUrl,
            {
                headers: {
                    'content-type': 'application/json',
                    'X-Requested-With': 'fetch'
                },
                credentials: 'same-origin',
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    if (typeof console !== 'undefined' && console.log) {
                        console.error(response);
                    }
                    throw new Error()
                }
            })
            .then(data => {
                if (!data || !data.items) {
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(data);
                    }
                    throw new Error("Invalid data format");
                }
                this.setState(prevState => {
                    for (let i = 0; i < data.items.length; i++) {
                        data.items[i].isSelected = false;
                        data.items[i].quantity = 0;
                    }
                    return {
                        itemsList: prevState.itemsList.concat(data.items),
                        
                        totalItems: data.totalItems,
                    };
                });
            })
            .catch((error) => {
                this.setState(prevState => ({
                    userMessages: prevState.userMessages.concat([
                        createUserMessage({
                            text: translateResourceString("/MyAccountPage/MyItems/ErrorLoadingItems"),
                            type: ERROR_USER_ALERT
                        })
                    ])
                }));
            });
    }

    setItemSelected = (code, isSelected) => {
        this.setState((prevState) => {
            let itemsListCopy = [...prevState.itemsList];
            let index = itemsListCopy.findIndex(inv => inv.Code === code);
            itemsListCopy[index].isSelected = isSelected;

            return {
                itemsList: itemsListCopy
            };
        });
    }

    handleOnClickSelectAll = (e) => {
        let isSelected = !!e.target.checked;
        this.setState((prevState) => {
            let itemsListCopy = [...prevState.itemsList];
            for (let i = 0; i < this.state.itemsList.length; i++) {
                itemsListCopy[i].isSelected = isSelected;
            }

            return {
                itemsList: itemsListCopy
            };
        });
    }

    setItemQuantity = (code, quantity) => {
        // Validate is a number
        this.setState((prevState) => {
            let itemsListCopy = [...prevState.itemsList];
            let index = itemsListCopy.findIndex(item => item.Code === code);
            itemsListCopy[index].quantity = quantity;

            return {
                itemsList: itemsListCopy
            };
        });
    }

    resetSelectionsAndQuantities = () => {
        this.setState((prevState) => {
            let itemsListCopy = [...prevState.itemsList];
            for (let i = 0; i < this.state.itemsList.length; i++) {
                itemsListCopy[i].isSelected = false;
                itemsListCopy[i].quantity = 0;
            }

            return {
                itemsList: itemsListCopy
            };
        });
    }

    addSelectedItemsToCart = () => {
        let addToCartList = [];
        let selectedItems = this.state.itemsList.filter((item) => item.isSelected && item.quantity > 0);
        for (let i = 0; i < selectedItems.length; i++) {
            addToCartList.push({ Code: selectedItems[i].Code, Quantity: selectedItems[i].quantity });
        }
        axios.post(this.props.AddItemsToCartEndpoint, JSON.stringify(addToCartList),
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                }
            })
            .then((response) => {
                if (response.status === 200) {
                    if (response.data && response.data.hasError) {
                        const message = response.data["errorMessages"];
                        if (message)
                            alert(message);
                        else
                            alert(translateResourceString('/MyAccountPage/MyItems/AddToCartError'));
                    } else {
                        this.resetSelectionsAndQuantities();
                    }
                }
            })
            .catch((error) => {
                alert(translateResourceString('/MyAccountPage/MyItems/AddToCartError'));
            })
            .finally(() => {
                miniCartClient.refreshAndShow();
            })
    }

    addMessage = ({ text, type }) => {
        this.setState(prevState => ({
            userMessages: prevState.userMessages.concat([
                createUserMessage({
                    text: text,
                    type: type
                })
            ])
        }))
    };

    onDismissMessage = (id) => {
        this.setState(prevState => ({
            userMessages: prevState.userMessages
                ? prevState.userMessages.filter((message) => message.id !== id)
                : []
        }));
    }

    render() {
        const {
            itemsList,
            totalItems,
            userMessages
        } = this.state;

        //const {

        //} = this.props;

        const disableAddToCart = !itemsList.find((item) => item.isSelected && item.quantity > 0);
        const selectAllChecked = !itemsList.find((item) => !item.isSelected);

        return (
            <React.Fragment>
                <MessagesList
                    messages={userMessages}
                    onDismiss={this.onDismissMessage}
                />
                {totalItems > 0
                    ?
                    <>
                        <button className={"btn btn-primary " + (disableAddToCart ? "disabled" : "")} onClick={this.addSelectedItemsToCart} disabled={disableAddToCart}>
                            {translateResourceString("/MyAccountPage/MyItems/AddToCartButton")}
                        </button>
                        <table className="table my-2">
                            <thead>
                                <tr>
                                    <th colSpan="2">
                                        <input type="checkbox" id="myItemsSelectAll" className="mr-2" checked={selectAllChecked} onChange={this.handleOnClickSelectAll} />
                                        <label htmlFor="myItemsSelectAll">{translateResourceString("/MyAccountPage/MyItems/SelectAllLabel")}</label>
                                    </th>
                                    <th style={{ minWidth: "210px" }}>{translateResourceString("/MyAccountPage/MyItems/LastPurchaseDateHeader")}</th>
                                    <th style={{ maxWidth: "130px" }}>{translateResourceString("/MyAccountPage/MyItems/QuantityHeader")}</th>
                                    <th style={{ minWidth: "145px" }} className="text-right">{translateResourceString("/MyAccountPage/MyItems/TotalHeader")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsList.map((item) =>
                                    <Item key={item.Code}
                                        item={item}
                                        setSelected={this.setItemSelected}
                                        setQuantity={this.setItemQuantity}
                                    />
                                )}
                            </tbody>
                        </table>
                    </>
                    :
                    <div>
                        {translateResourceString("/MyAccountPage/MyItems/NoItemsMessage")}
                    </div>
                }
            </React.Fragment>
        );
    }
}



export default MyItemsApp;